import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import { DelegatesLink } from './index.styles'

export const DelegatesEventsInfo = ({
  companyId,
  isDelegate,
  futureEventsCount,
  pastEventsCount,
  delegatesCount = 0,
}: {
  companyId?: number
  isDelegate?: boolean
  futureEventsCount?: number
  pastEventsCount?: number
  delegatesCount?: number
}) => {
  const { t } = useTranslation()

  const delegatesCountText = useMemo(() => {
    const text = futureEventsCount ? t(translationKeys.EVENT_ATTENDING) : t(translationKeys.EVENT_ATTENDED)
    if (isDelegate || !futureEventsCount) {
      return text
    }

    if (!delegatesCount) {
      return ''
    }

    return `${delegatesCount} ${t(
      delegatesCount > 1 ? translationKeys.DELEGATES : translationKeys.DELEGATE,
    )} ${text.toLowerCase()}`
  }, [delegatesCount, isDelegate, futureEventsCount, t])

  const eventsText = useMemo(() => {
    const text = futureEventsCount || pastEventsCount

    if (futureEventsCount) {
      return `${text} ${t(
        futureEventsCount > 1 ? translationKeys.UPCOMING_EVENTS : translationKeys.UPCOMING_EVENT,
      ).toLowerCase()}`
    }

    if (pastEventsCount) {
      return `${text} ${t(pastEventsCount > 1 ? translationKeys.PAST_EVENTS : translationKeys.PAST_EVENT).toLowerCase()}`
    }
    return ''
  }, [futureEventsCount, pastEventsCount, t])

  return (
    <DelegatesLink href={`/plus/profile/${companyId}/delegates`} id="profile-info_delegates">
      {(!!futureEventsCount || !!pastEventsCount) && `${delegatesCountText} ${eventsText}`}
    </DelegatesLink>
  )
}
